import React from 'react';
import { formatTag } from './helpers';

const HighlightStats = ({ highlight }) => (
  <div className="highlight-stats">
    <div className="highlight-stat-item">
      <span className="highlight-stat-label">Round</span>
      <span className="highlight-stat-value">{highlight.round_number}</span>
    </div>
    <div className="highlight-stat-item">
      <span className="highlight-stat-label">Kills</span>
      <span className="highlight-stat-value">{highlight.kills}</span>
    </div>
    <div className="highlight-stat-item">
      <span className="highlight-stat-label">Headshots</span>
      <span className="highlight-stat-value">{highlight.headshots}</span>
    </div>
    {highlight.weapons_used && highlight.weapons_used.length > 0 && (
      <div className="highlight-stat-item weapons">
        <span className="highlight-stat-label">Weapons</span>
        <span className="highlight-stat-value">{highlight.weapons_used.join(', ')}</span>
      </div>
    )}
    {highlight.special_tags && highlight.special_tags.length > 0 && (
      <div className="highlight-tags">
        {highlight.special_tags.map(tag => (
          <span key={tag} className={`highlight-tag tag-${tag}`}>{formatTag(tag)}</span>
        ))}
      </div>
    )}
  </div>
);

export default HighlightStats;
